export class AutomationListFilter {
    constructor({
                    //attributes
                    id = null,
                    automation_list_id = null,
                    type = '',
                    condition = '',
                    value = '',
                    subfilters = [],
                    extra_conditions = {},
                    created_at = null,
                    updated_at = new Date(),
                } = {}) {

        //fill attributes
        this.id = id;
        this.automation_list_id = automation_list_id;
        this.type = type;
        this.condition = condition;
        this.subfilters = (subfilters||[]).map(s=>new AutomationListFilter(s));
        this.extra_conditions = extra_conditions;
        this.created_at = created_at;
        this.updated_at = updated_at;


        let getVal = (val) => val!==undefined && val!==null ? val.toString() : "";
        if (Array.isArray(value))
            this.value=value.map(getVal);
        else
            this.value=getVal(value);
    }
}

export function createAutomationListFilter(data = {}) {
    return Object.freeze(new AutomationListFilter(data));
}